import { render, staticRenderFns } from "./social-account.vue?vue&type=template&id=a4b06b30&scoped=true&"
import script from "./social-account.vue?vue&type=script&lang=js&"
export * from "./social-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b06b30",
  null
  
)

export default component.exports